import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { hooks } from '@lifesize/clients.sdk';
import { colors } from '@lifesize/ux-assets';
import { moderatorActions } from '@lifesize/nucleus';
import { ReactComponent as HandIcon } from '@lifesize/ux-assets/vectors/svgIcons/hand.svg';
import { makeStyles, Theme, Tooltip } from '@material-ui/core';

interface Props {
  participant: any;
}

export const ParticipantRaisedHandButton = ({ participant }: Props) => {
  const classes = useStyles({});
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { handRaised, isSelf } = participant;
  const dispatch = useDispatch();

  const handleSelectRaisedHandClicked = (participantId) => {
    dispatch(moderatorActions.lowerParticipantHand(participantId));
  };

  if (!handRaised) return null;

  if (!!handRaised && userIsModerator && !isSelf) {
    return (
      <Tooltip
        arrow={true}
        placement="top"
        title={
          <FormattedMessage
            id="components.inCall.participantDrawer.tooltip.lowerHand"
            defaultMessage="Click to Lower Hand"
          />
        }
      >
        <button
          data-testid="lowerParticipantHand"
          className={classes.button}
          onClick={() => handleSelectRaisedHandClicked(participant?.participantId)}
        >
          <HandIcon className={`${classes.buttonIcon} ${classes.raisedHandIcon}`} />
        </button>
      </Tooltip>
    );
  }
  return (
    <div className={`${classes.button} ${classes.noButton}`}>
      <HandIcon className={`${classes.buttonIcon} ${classes.raisedHandIcon}`} />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    alignItems: 'center',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '1em', // prevents global button default
    height: '100%', // necessary for the drop-down button
    justifyContent: 'center',
    margin: '0 3px',
    outline: 'none',
    padding: 0,
    position: 'relative',
    width: '2em'
  },
  noButton: {
    cursor: 'default'
  },
  buttonIcon: {
    height: '2em',
    width: 'auto'
  },
  raisedHandIcon: {
    color: colors.agileGreen
  }
}));

export default ParticipantRaisedHandButton;
